// BEGIN OLD LAYOUT ONLY — remove once old layout is retired.
// In the old layout (body.no-body-padding), Beamer's overflow:hidden on a body
// with padding-top:50px creates a 50px gap. We override overflow and use
// position:fixed instead. All four style properties are set atomically in the
// callback to avoid a snap-to-top frame.
//
// The observer fires on ANY body class change, so we only capture scrollY on
// the transition into the locked state. Re-capturing while already locked
// would read 0 (body is position:fixed) and lose the real scroll position.
export function createBeamerScrollObserver() {
  let lockedScrollY = 0
  let isLocked = document.body.classList.contains('beamer_noscroll')
  if (isLocked) lockedScrollY = window.scrollY

  return new MutationObserver(() => {
    const shouldLock = document.body.classList.contains('beamer_noscroll')
    if (shouldLock === isLocked) return

    if (shouldLock) {
      lockedScrollY = window.scrollY
      document.body.style.overflow = 'unset'
      document.body.style.position = 'fixed'
      document.body.style.top = `-${lockedScrollY}px`
      document.body.style.width = '100%'
    } else {
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      window.scrollTo(0, lockedScrollY)
    }
    isLocked = shouldLock
  })
}
// END OLD LAYOUT ONLY
